<template>
  <div>
    <div v-if="tieneAlgunRolCorrespondiente">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane key="1">
           <span slot="tab">
                <a-icon type="check-square"/>
                Aprobaciones
             </span>
          <g-master name="overtime"
                    @params="paramsTable"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    modalWidth="80%"
                    :actions="master.actions"
                    @action="masterAction"
                    :beforeSend="master.beforeSend"
                    ref="master"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <span slot="estadoRenderer" slot-scope="{text}">
              <div>
                <a-tag color="blue">{{text}}</a-tag>
              </div>
            </span>
          </g-master>
        </a-tab-pane>
        <a-tab-pane key="2">
             <span slot="tab">
                <a-icon type="schedule"/>
               Marcaciones vs programación
             </span>
          <a-collapse accordion>
            <a-collapse-panel key="1" header="Reporteador marcaciones vs programación">
              <a-form-model :model="marcacionesYProgramacion" v-bind="fiOptions" :rules="formRules"
                            ref="form">
                <a-row :gutter="[8,8]">
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Empleado')" prop="id_emp" v-bind="fiOptions" has-feedback>
                      <form-model-lookup style="width: 100%"
                                         v-model="marcacionesYProgramacion.id_emp"
                                         endpoint="empleados"
                      >
                      </form-model-lookup>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Año')" prop="year" v-bind="fiOptions">
                      <a-select v-model="marcacionesYProgramacion.year" style="width: 100%">
                        <a-select-option v-for="year_ in years" :key="year_">
                          {{ year_ }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Mes')" prop="month" v-bind="fiOptions">
                      <a-select v-if="!filtroRangoMes" v-model="marcacionesYProgramacion.month" style="width: 80%">
                        <a-select-option v-for="month_ in months_name" :key="month_.value">
                          {{ month_.name }}
                        </a-select-option>
                      </a-select>
                      <a-row v-if="filtroRangoMes" :gutter="[8,8]">
                        <a-col>
                          <a-select v-model="marcacionesYProgramacion.month_initial" style="width: 40%">
                            <a-select-option v-for="month_ in months_name" :key="month_.value">
                              {{ month_.name }}
                            </a-select-option>
                          </a-select>
                          -
                          <a-select v-model="marcacionesYProgramacion.month_end" style="width: 40%">
                            <a-select-option v-for="month_ in months_name" :key="month_.value">
                              {{ month_.name }}
                            </a-select-option>
                          </a-select>
                          <a-tooltip placement="topLeft" title="Modificar filtro de mes">
                            <a-button @click="changeRangoMes" type="primary" icon="retweet"
                                      style="margin-left: 3px; width: 10%"/>
                          </a-tooltip>
                        </a-col>
                      </a-row>
                      <a-tooltip v-if="!filtroRangoMes" placement="topLeft" title="Modificar filtro por rango de mes">
                        <a-button @click="changeRangoMes" type="primary" icon="retweet"
                                  style="margin-left: 3px; width: 10%"/>
                      </a-tooltip>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-form-model>
              <g-btn-excel :endpoint="endpointExcelMarcaciones" :params="paramsExcelMarcaciones"
                           :fileName="'MarcacionesVsProgramacion'"/>
            </a-collapse-panel>
          </a-collapse>
          <br>
          <g-master name="overtime"
                    :endpoint="masterMarcacinesVsProgramacion.endpoint"
                    :tableSetup="masterMarcacinesVsProgramacion.tableSetup"
                    modalWidth="80%"
                    :actions="masterMarcacinesVsProgramacion.actions"
                    @params="paramsTableMarcacionesVsProgramacion"
                    ref="masterMarcacionesVsProgramacion"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcelMarcacionesVsProgramacion" :params="paramsExcelMarcacionesVsProgramacion"
                           :fileName="'MarcacionesVsProgramacion'"/>
            </template>
          </g-master>

        </a-tab-pane>
      </a-tabs>
      <a-modal :title="tituloModal"
               :visible="visibleModal"
               @ok="accionModalOk()"
               :confirmLoading="loadingModal"
               @cancel="accionModalCancel()"
               style="top: 20px;">
        <span>{{mensajeModal}}</span>
        <br/>
      </a-modal>
    </div>
    <div v-else>
      <a-result
        status="warning"
        title="Permiso denegado"
        sub-title="A continuación se muestra la razón por la cual no puede acceder a esta pantalla"
      >
        <div class="desc">
          <p style="font-size: 16px;">
            <strong>Situación:</strong>
          </p>
          <p>
            <a-icon :style="{ color: 'red' }" type="close-circle"/>
            Este usuario no cumple con el rol adecuado, por favor contacte a un administrador.
          </p>
        </div>
      </a-result>
    </div>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        formRules: {},
        filtroRangoMes: false,
        months_name: [
          {name: 'Enero', value: 1},
          {name: 'Febrero', value: 2},
          {name: 'Marzo', value: 3},
          {name: 'Abril', value: 4},
          {name: 'Mayo', value: 5},
          {name: 'Junio', value: 6},
          {name: 'Julio', value: 7},
          {name: 'Agosto', value: 8},
          {name: 'Septiembre', value: 9},
          {name: 'Octubre', value: 10},
          {name: 'Noviembre', value: 11},
          {name: 'Diciembre', value: 12}
        ],
        marcacionesYProgramacion: {
          year: parseInt(moment().format('YYYY')),
          month: parseInt(moment().format('MM')),
          month_initial: parseInt(moment().format('MM')),
          month_end: parseInt(moment().format('MM')),
          id_emp: null
        },
        years: [],
        paramsT: {},
        paramsTMarcacionesVsProgramacion: {},
        endpointExcel: 'clock_mark_/downloadExcel',
        endpointExcelMarcaciones: 'marcaciones/downloadExcel',
        endpointExcelMarcacionesVsProgramacion: 'marcaciones_vs_programacion_/downloadExcel',
        fileNameExcel: 'AprobacionTurnos',
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        status: {
          h_lookup_type: 'ESTADO_CONCEPTO_TIEMPO',
          use_code: true
        },
        colSpan: {
          xs: 12,
          md: 8
        },
        fiOptions: {},
        tituloModal: '',
        mensajeModal: '',
        loadingModal: false,
        tipoAccionModal: null,
        visibleModal: false,
        filaSeleccionada: null,
        master: {
          actions: [
            {
              name: 'aprobarSolicitudesMasivas',
              text: 'Aprobar solicitudes',
              permisos: [],
              props: {icon: 'check', type: 'primary'},
              fnVisible: () => !this.$userIsInrol('Management')
            },
            {
              name: 'rechazarSolicitudesMasivas',
              text: 'Rechazar solicitudes',
              permisos: [],
              props: {icon: 'close', type: 'danger'},
              fnVisible: () => !this.$userIsInrol('Management')
            }
          ],
          endpoint: 'clock_mark',
          tableSetup: {
            allowSelect: true,
            selectType: 'checkbox',
            selectedRowKeys: [],
            selectedRows: [],
            actions: {
              actions: [
                {
                  name: 'aprobarIndividualmente',
                  text: 'Aprobar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'check'},
                  fnVisible: () => !this.$userIsInrol('Management')
                },
                {
                  name: 'rechazarIndividualmente',
                  text: 'Rechazar',
                  permisos: [],
                  props: {size: 'small', icon: 'close', type: 'link', style: {color: 'red'}},
                  fnVisible: () => !this.$userIsInrol('Management')
                }
              ]
            },
            customSlots: ['estadoRenderer'],
            tableConfig: {
              rowKey: 'id_clock_mark',
              pagination: {
                pageSize: 20,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '50', '100', '200'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: '#', dataIndex: 'id_clock_mark', sorter: true},
              {title: 'ID del empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre completo', dataIndex: 'nombre_empleado', sorter: true},
              {title: 'Grupo', dataIndex: 'grupo', sorter: true},
              {title: 'Puesto', dataIndex: 'puesto', sorter: true},
              {title: 'Acción realizada', dataIndex: 'reader', sorter: true},
              {title: 'Fecha y hora', dataIndex: 'fecha_hora', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'status_desc',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          }
        },
        masterMarcacinesVsProgramacion: {
          actions: false,
          endpoint: 'marcaciones_vs_programacion',
          tableSetup: {
            actions: false,
            tableConfig: {
              rowKey: 'id',
              pagination: {
                pageSize: 20,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '50', '100', '200'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'month_desc', sorter: true},
              {title: 'Codigo', dataIndex: 'codigo', sorter: true},
              {title: 'Persona', dataIndex: 'persona', sorter: true},
              {title: 'Pro. Inicial', dataIndex: 'progini', sorter: true},
              {title: 'Pro. Final', dataIndex: 'progfin', sorter: true},
              {title: 'Novedad', dataIndex: 'novedad', sorter: true},
              {title: 'ID Turno', dataIndex: 'idturno', sorter: true},
              {title: 'Turno', dataIndex: 'turno', sorter: true},
              {title: 'Inicio', dataIndex: 'inicio', sorter: true},
              {title: 'Fin', dataIndex: 'fin', sorter: true},
              {title: 'Descripcion', dataIndex: 'descripción', sorter: true},
              {title: 'Creado por', dataIndex: 'progcreated', sorter: true},
              {title: 'Entrada', dataIndex: 'entrada', sorter: true},
              {title: 'Salida', dataIndex: 'salida', sorter: true}
            ]
          }
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.yearsSelect()
      this.initFormRules()
    },
    methods: {
      changeRangoMes () {
        this.filtroRangoMes = !this.filtroRangoMes
      },
      yearsSelect () {
        for (let i = 2019; i <= (2019 + (parseInt(moment().format('YYYY')) - 2019)); i++) {
          this.years.push(parseInt(i))
        }
      },
      initFormRules () {
        this.formRules = {
          year: [{required: false, message: 'Valor requerido'}],
          month: [{required: false, message: 'Valor requerido'}]
        }
      },
      paramsTable (params) {
        this.paramsT = params
      },
      paramsTableMarcacionesVsProgramacion (params) {
        this.paramsTMarcacionesVsProgramacion = params
      },
      accionModalOk () {
        if (this.tipoAccionModal === 'aprobarIndividual') {
          this.loadingModal = true
          this.filaSeleccionada['accion'] = 'aprobarIndividual'
          this.realizarPeticion(this.filaSeleccionada)
        } else if (this.tipoAccionModal === 'rechazarIndividual') {
          this.loadingModal = true
          this.filaSeleccionada['accion'] = 'rechazarIndividual'
          this.realizarPeticion(this.filaSeleccionada)
        } else if (this.tipoAccionModal === 'aprobarMasivamente') {
          this.loadingModal = true
          this.realizarPeticion({datos: this.master.tableSetup.selectedRows, accion: 'aprobarMasivamente'})
        } else if (this.tipoAccionModal === 'rechazarMasivamente') {
          this.loadingModal = true
          this.realizarPeticion({datos: this.master.tableSetup.selectedRows, accion: 'rechazarMasivamente'})
        }
      },
      realizarPeticion (data) {
        this.httpClient.getInstance().post('ejecutar_accion_turno', data).then((response) => {
          Mensajes.success('Correcto', 'Información actualizada correctamente.')
          this.$refs.master.$refs.datatable.loadData()
        }).catch((error) => {
          Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible actualizar la información.'))
        }).then(() => {
          this.visibleModal = false
          this.loadingModal = false
        })
      },
      accionModalCancel () {
        this.visibleModal = false
        this.master.tableSetup.allowSelect = true
      },
      masterAction (action) {
        switch (action.action) {
          case 'aprobarIndividualmente':
            this.tituloModal = 'Aprobar turno'
            this.mensajeModal = '¿Desea aprobar este turno?'
            this.tipoAccionModal = 'aprobarIndividual'
            this.visibleModal = true
            this.master.tableSetup.allowSelect = false
            this.filaSeleccionada = action.record
            break
          case 'rechazarIndividualmente':
            this.tituloModal = 'Rechazar turno'
            this.mensajeModal = '¿Desea rechazar este turno?'
            this.tipoAccionModal = 'rechazarIndividual'
            this.visibleModal = true
            this.master.tableSetup.allowSelect = false
            this.filaSeleccionada = action.record
            break
          case 'aprobarSolicitudesMasivas':
            if (JsUtils.isEmpty(this.master.tableSetup.selectedRows)) {
              Mensajes.info('Información', 'No hay turnos seleccionados')
            } else {
              this.tituloModal = 'Aprobar solicitudes masivas'
              this.mensajeModal = '¿Desea aprobar todos los turnos seleccionados?'
              this.tipoAccionModal = 'aprobarMasivamente'
              this.visibleModal = true
            }
            break

          case 'rechazarSolicitudesMasivas':
            if (JsUtils.isEmpty(this.master.tableSetup.selectedRows)) {
              Mensajes.info('Información', 'No hay turnos seleccionados')
            } else {
              this.tituloModal = 'Rechazar solicitudes masivas'
              this.mensajeModal = '¿Desea rechazar todos los turnos seleccionados?'
              this.tipoAccionModal = 'rechazarMasivamente'
              this.visibleModal = true
            }
            break
        }
      }
    },
    computed: {
      tieneAlgunRolCorrespondiente () {
        return this.$userIsInrol('ConfirmaTurno') || this.$userIsInrol('ApruebaTurno') || this.$userIsInrol('AutorizaTurno')
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      },
      paramsExcelMarcaciones () {
        return {...this.marcacionesYProgramacion, rango_mes: this.filtroRangoMes}
      },
      paramsExcelMarcacionesVsProgramacion () {
        return {...this.paramsTMarcacionesVsProgramacion, columns: this.masterMarcacinesVsProgramacion.tableSetup.columns}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/OvertimeTurn/OvertimeTurn.vue